import { render, staticRenderFns } from "./lang-switch.vue?vue&type=template&id=318545c4&"
import script from "./lang-switch.vue?vue&type=script&lang=js&"
export * from "./lang-switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports